import { useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  appRoutes,
  findAppRouteByPathname,
  isRouteEnabledForOrgType,
} from '../constants/appRoutes';
import useSweepNavigate from '../navigation-utils/useSweepNavigate';
import { useDefaultEnv } from '../components/pages/environments/DefaultEnvContext';

export const useRestrictedRouteGuard = () => {
  const { pathname } = useLocation();
  const { navigate } = useSweepNavigate();
  const defaultCreationEnv = useDefaultEnv();
  const orgType = defaultCreationEnv?.orgType;

  useEffect(() => {
    const appRoute = findAppRouteByPathname(pathname);
    if (appRoute && !isRouteEnabledForOrgType(appRoute, orgType)) {
      navigate(appRoutes.getStarted.route, { replace: true });
    }
  }, [orgType, pathname, navigate]);
};
